import get from 'lodash/get';
import API from '@/api';
import isEmpty from 'lodash/isEmpty';
import * as Sentry from '@sentry/vue';

const NotificationTypes = Object.freeze({
  SUCCESS: 0,
  WARNING: 1,
  ERROR: 2,
});

const DEFAULT_TIMEOUT = 6000;

const types = {
  START_LOADING: 'START_LOADING',
  END_LOADING: 'END_LOADING',
  SET_SUCCESS_NOTIFICATION: 'SET_SUCCESS_NOTIFICATION',
  SET_ERROR_NOTIFICATION: 'SET_ERROR_NOTIFICATION',
  SET_WARNING_NOTIFICATION: 'SET_WARNING_NOTIFICATION',
};

const state = {
  loading: false,
  notification: {
    message: '',
    type: NotificationTypes.SUCCESS,
    show: false,
    color: null,
    timeout: DEFAULT_TIMEOUT,
  },
};

const getters = {};

const mutations = {
  [types.START_LOADING](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.loading = true;
  },
  [types.END_LOADING](appState) {
    // eslint-disable-next-line no-param-reassign
    appState.loading = false;
  },
  [types.SET_SUCCESS_NOTIFICATION](appState, params = {}) {
    if (isEmpty(params) || isEmpty(params.message)) return;
    Object.assign(appState.notification, {
      message: params.message,
      type: NotificationTypes.SUCCESS,
      show: true,
      color: 'success',
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
  },
  [types.SET_ERROR_NOTIFICATION](appState, params = {}) {
    if (isEmpty(params) || isEmpty(params.message)) return;
    Object.assign(appState.notification, {
      message: params.message,
      type: NotificationTypes.ERROR,
      show: true,
      color: 'error',
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
  },
  [types.SET_WARNING_NOTIFICATION](appState, params = {}) {
    if (isEmpty(params) || isEmpty(params.message)) return;
    Object.assign(appState.notification, {
      message: params.message,
      type: NotificationTypes.WARNING,
      show: true,
      color: 'error',
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
  },
};

const actions = {
  async addLoading({ commit, dispatch }, apiCalls) {
    apiCalls.unshift(commit(types.START_LOADING));
    const calls = await Promise.all(apiCalls);
    commit(types.END_LOADING);
    return calls;
  },
  setSuccessNotification({ commit }, params) {
    commit(types.SET_SUCCESS_NOTIFICATION, params || {});
  },
  setErrorNotification({ commit }, params) {
    commit(types.SET_ERROR_NOTIFICATION, params);
    if (params.errorToSend) {
      Sentry.captureMessage(params.message, {
        error: params.errorToSend,
        user_email: params.userEmail || params.user_email || 'Anonymous',
      });
    }
  },
  setWarningNotification({ commit }, params) {
    commit(types.SET_WARNING_NOTIFICATION, params);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
